import { render, staticRenderFns } from "./load-list.vue?vue&type=template&id=2b0120dc&scoped=true&"
import script from "./load-list.vue?vue&type=script&lang=js&"
export * from "./load-list.vue?vue&type=script&lang=js&"
import style0 from "./load-list.vue?vue&type=style&index=0&id=2b0120dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0120dc",
  null
  
)

export default component.exports